import { render, staticRenderFns } from "./SideBasket.component.vue?vue&type=template&id=904db89c"
import script from "./SideBasket.component.vue?vue&type=script&lang=js"
export * from "./SideBasket.component.vue?vue&type=script&lang=js"
import style0 from "./SideBasket.component.vue?vue&type=style&index=0&id=904db89c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports